const danhSachBaoCaoTable = (state) => state.danhSachBaoCaoTable;

const danhSachBaoCaoVanBanDiTable = (state) =>
  state.danhSachBaoCaoVanBanDiTable;

export default {
  danhSachBaoCaoTable,
  danhSachBaoCaoVanBanDiTable,
};
